/* eslint-disable  */
import React, { useContext } from 'react';
import { CheckboxDropdownContext } from '../context';
import { Checkbox } from '../../Checkbox';
import ChevronDown from '@dtsl/icons/dist/icons/react/ChevronDown';
import styles from '@dtsl/css-checkbox-dropdown/dist/index.module.css';
const CheckboxDropdownButton = () => {
  const {
    isOpen,
    setIsOpen
  } = useContext(CheckboxDropdownContext);
  return /*#__PURE__*/React.createElement("div", {
    className: styles['sib-checkbox-dropdown-wrapper'],
    onClick: event => {
      event.stopPropagation();
      setIsOpen(!isOpen);
    }
  }, /*#__PURE__*/React.createElement(Checkbox, {
    variant: "positive",
    identifier: "positive_checkbox",
    label: ""
    // checked={checked} // checked state of checkbox.
    ,
    name: "checkbox_name",
    value: "checkbox_value",
    disabled: false
    // onChange={() => {
    //   setChecked(!checked);
    // }}
  }), /*#__PURE__*/React.createElement("figure", {
    className: `${styles['sib-arrow-down-root']} ${isOpen ? styles['sib-rotate-chevron'] : ''}`
  }, /*#__PURE__*/React.createElement(ChevronDown, null)));
};
CheckboxDropdownButton.propTypes = {};
export default CheckboxDropdownButton;